import ReactGA from "react-ga4";

export const initializeAnalytics = (measurementId) => {
  ReactGA.initialize(measurementId);
};

export const trackPageView = (path) => {
  ReactGA.send({ hitType: "pageview", page: path });
};
